import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initMatomo, trackPageView } from "../services/matomo";

export default function Matomo() {
  const location = useLocation();

  
useEffect(() => {
    initMatomo().catch((error) => {
      console.error("No se pudo inicializar Matomo:", error.message);
    });
  }, []);


  useEffect(() => {
    if (window.__MATOMO_INITED__) trackPageView();
  }, [location.pathname, location.search, location.hash]);

  return null;
}